import { render, staticRenderFns } from "./BankDepositForm.vue?vue&type=template&id=8b5b1e64&scoped=true"
import script from "./BankDepositForm.vue?vue&type=script&lang=js"
export * from "./BankDepositForm.vue?vue&type=script&lang=js"
import style0 from "./BankDepositForm.vue?vue&type=style&index=0&id=8b5b1e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5b1e64",
  null
  
)

export default component.exports